module.exports = __webpack_public_path__ + "static/media/HomepagePlugin.44140b1d.png";